import { useState } from "react";
import { MAKE_LOGOS, monogramColor } from "@/lib/promotions";

export function BrandMark({ make, logoUrl, size = 44 }) {
  const [err, setErr] = useState(false);
  const src = logoUrl || MAKE_LOGOS[(make || "").toLowerCase()] || null;
  const initials = (make || "?").trim().slice(0, 2).toUpperCase() || "?";
  if (src && !err) {
    return (
      <div style={{ width: size, height: size }} data-testid="brand-mark-logo"
        className="flex shrink-0 items-center justify-center overflow-hidden rounded-lg border border-slate-200 bg-white p-1.5 dark:border-slate-700">
        <img src={src} alt={make || "brand"} onError={() => setErr(true)} className="max-h-full max-w-full object-contain" />
      </div>
    );
  }
  return (
    <div style={{ width: size, height: size }} data-testid="brand-mark-monogram"
      className={`flex shrink-0 items-center justify-center rounded-lg text-sm font-black text-white ${monogramColor(make)}`}>
      {initials}
    </div>
  );
}
